export default {
  'schedule_window.window_length.label': 'Window Length',
  'schedule_window.window_start_hour.label': 'Window Start Hour',
  'schedule_window.start_time': 'Starts {{startTime}}',
  'schedule_window.end_time': 'Ends {{endTime}}'
}
